/**
 * @generated SignedSource<<8e148770978350f8fb6ac3501749b1b1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type topicSeoTopic$data = {
  readonly description: {
    readonly text: string | null | undefined;
  } | null | undefined;
  readonly metaDescription: string | null | undefined;
  readonly name: string;
  readonly urlAlias: string;
  readonly " $fragmentSpreads": FragmentRefs<"hooksUseDeepLinkTagsBase" | "hooksUseDynamicMetaTags">;
  readonly " $fragmentType": "topicSeoTopic";
};
export type topicSeoTopic$key = {
  readonly " $data"?: topicSeoTopic$data;
  readonly " $fragmentSpreads": FragmentRefs<"topicSeoTopic">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "topicSeoTopic",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FormattedValue",
      "kind": "LinkedField",
      "name": "description",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "text",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "urlAlias",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "metaDescription",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "hooksUseDeepLinkTagsBase"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "hooksUseDynamicMetaTags"
    }
  ],
  "type": "Topic",
  "abstractKey": null
};

(node as any).hash = "11d0e5f834f0c304c9598873d36910b0";

export default node;
